module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/promoCoins-a6fdea813c1f2fe6d7db626783833a05.png";